module.exports = __webpack_public_path__ + "img/discord.1967e09a.svg";